///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { GtthKeyValueDTO } from '../../generated/shared-types.model';
import { Observable, Subject } from 'rxjs';
import { GtthLayerDtoModel } from '../../services/project-socket/dto/gtth-layer-dto.model';
import { GtthLogicalTopology } from '../../project-view-panel/logical-topology/entities/logical-topology';

@Injectable({
    providedIn: 'root'
})
export class GtthProjectInfoViewService {
    public isShow = false;
    public projectName: string;
    public isShowLayers = false;
    public layersOptions: GtthKeyValueDTO[];
    public activeLayer: number;
    public numberOfConnectedTu = 0;
    public nodesToConnect: Map<number, number>;
    private readonly layerChangedSubject: Subject<number>;

    constructor() {
        this.layerChangedSubject = new Subject<number>();
        this.nodesToConnect = new Map();
    }

    public layerChangedSubscription(): Observable<number> {
        return this.layerChangedSubject.asObservable();
    }

    showInfo() {
        this.isShow = true;
    }

    setProjectName(projectName: string) {
        this.projectName = projectName;
    }

    showLayers(layers: GtthLayerDtoModel[], activeLayer: number): void {
        this.layersOptions = [{ key: GtthLogicalTopology.WHOLE_TOPOLOGY_LAYER_INDEX, value: 'Whole topology' }];
        layers.forEach((layer: GtthLayerDtoModel) => {
            this.layersOptions.push({ key: layer.layerIndex, value: layer.getFullName() });
        });
        this.activeLayer = activeLayer;
        this.layerChangedSubject.next(this.activeLayer);
        this.isShowLayers = true;
    }

    getLayersAsKeyValueObj(): Record<number, string> {
        if (this.layersOptions?.length) {
            const layers: Record<string, string> = {};
            this.layersOptions.forEach((layer: GtthKeyValueDTO) => {
                layers[layer.key] = layer.value;
            });
            return layers;
        }
    }

    layerChanged() {
        this.layerChangedSubject.next(this.activeLayer);
    }

    setNumberOfConnectedTu(value: number) {
        this.numberOfConnectedTu = value;
    }

    incrementNodesToConnectCount(nodeLayerIdx: number): void {
        if (!this.nodesToConnect.has(GtthLogicalTopology.WHOLE_TOPOLOGY_LAYER_INDEX)) {
            this.nodesToConnect.set(GtthLogicalTopology.WHOLE_TOPOLOGY_LAYER_INDEX, 0);
        }
        if (!this.nodesToConnect.has(nodeLayerIdx)) {
            this.nodesToConnect.set(nodeLayerIdx, 0);
        }

        this.nodesToConnect.set(
            GtthLogicalTopology.WHOLE_TOPOLOGY_LAYER_INDEX,
            this.nodesToConnect.get(GtthLogicalTopology.WHOLE_TOPOLOGY_LAYER_INDEX) + 1
        );
        this.nodesToConnect.set(nodeLayerIdx, this.nodesToConnect.get(nodeLayerIdx) + 1);
    }

    decrementNodesToConnectCount(nodeLayerIdx: number): void {
        this.nodesToConnect.set(
            GtthLogicalTopology.WHOLE_TOPOLOGY_LAYER_INDEX,
            this.nodesToConnect.get(GtthLogicalTopology.WHOLE_TOPOLOGY_LAYER_INDEX) - 1
        );
        this.nodesToConnect.set(nodeLayerIdx, this.nodesToConnect.get(nodeLayerIdx) - 1);
    }

    clearNodesToConnectCount(): void {
        this.nodesToConnect.clear();
    }

    hideInfo() {
        this.isShow = false;
        this.projectName = '';
        this.numberOfConnectedTu = 0;
        this.nodesToConnect.clear();
    }

    hideLayers() {
        this.activeLayer = -1;
        this.layersOptions = [];
        this.isShowLayers = false;
    }
}
